import {
  faCheckCircle,
  faTimesCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { reduce } from "et3-type-guards";

import i18n from "../../../constants/i18n";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import getUserAdvancedStore from "../../../stores/user-store/advanced-store";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import {
  CONFIRMATION_ACTIONS_HEIGHT,
  CONFIRMATION_ACTIONS_WIDTH,
  CONFIRMATION_BOX_HEIGHT,
  CONFIRMATION_BOX_RADIUS,
  CONFIRMATION_BOX_WIDTH,
  CONFIRMATION_OVERLAY_HEIGHT,
  CONFIRMATION_OVERLAY_WIDTH,
  CONFIRMATION_TEXT_FONT_SIZE,
  CONFIRMATION_TEXT_MAX_WIDTH,
  CONFIRMATION_Z_INDEX
} from "../confirmation-pop-up-constants";

const RemoveSilentBanPopUp = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const userID = getUserAdvancedStore().currentUserId.get();
  const userUUID = reduce(
    () => getUserAdvancedStore().userData.get(userID).userUUID,
    ""
  );
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={CONFIRMATION_OVERLAY_WIDTH}
      height={CONFIRMATION_OVERLAY_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{
        position: "fixed",
        top: 0,
        zIndex: CONFIRMATION_Z_INDEX
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="column"
        justifyContent="space-between"
        alignItems="center"
        withShadow={true}
        width={CONFIRMATION_BOX_WIDTH}
        height={CONFIRMATION_BOX_HEIGHT}
        color={colors.all.white}
        style={{
          position: "relative",
          borderRadius: CONFIRMATION_BOX_RADIUS,
          zIndex: CONFIRMATION_Z_INDEX
        }}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={CONFIRMATION_TEXT_FONT_SIZE}
          text={i18n.get("REMOVE_SILENT_BAN_POPUP_TEXT")}
          isSpan={false}
          color={colors.all.black}
          style={{ maxWidth: CONFIRMATION_TEXT_MAX_WIDTH * unitX }}
        />
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          fDirection="row"
          justifyContent="space-between"
          alignItems="center"
          withShadow={false}
          width={CONFIRMATION_ACTIONS_WIDTH}
          height={CONFIRMATION_ACTIONS_HEIGHT}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <FontAwesomeIcon
            className="clickable"
            onClick={() => {
              getUserAdvancedStore().removeSilentBanPopUp(userUUID);
            }}
            icon={faCheckCircle}
            color={colors.all.green}
            style={{}}
            size="3x"
          />
          <FontAwesomeIcon
            className="clickable"
            onClick={() => getCorePopUpStore().closeConfirmationPopUps()}
            icon={faTimesCircle}
            color={colors.all.red}
            style={{}}
            size="3x"
          />
        </ET3Div>
      </ET3Div>
    </ET3Div>
  );
});
export default RemoveSilentBanPopUp;
